import React, { useContext, useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { BsPlus } from 'react-icons/bs'
import logo from '../../assets/final_logo.png'
import { FaChevronLeft } from 'react-icons/fa6'

import { ChatMessage, Citation, CosmosDBStatus } from '../../api'
import { ChatHistoryPanel } from '../ChatHistory/ChatHistoryPanel'

interface SidebarProps {
  isSidebarCollapsed: boolean
  setIsSidebarCollapsed: (value: boolean) => void
  newChat: () => void
}

function Sidebar({ isSidebarCollapsed, setIsSidebarCollapsed, newChat }: SidebarProps) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const sidebarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        isMobile && // Only do this on mobile
        !isSidebarCollapsed && // Only if sidebar is open
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        setIsSidebarCollapsed(true)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isSidebarCollapsed, isMobile, sidebarRef])

  return (
    <div ref={sidebarRef} className="md:static fixed z-50">
      <motion.aside
        animate={{ width: isSidebarCollapsed ? '0px' : '256px' }}
        initial={{ width: '256px' }}
        transition={{ type: 'spring', stiffness: 500, damping: 50 }}
        style={{ minWidth: '0px' }}
        className={` bg-[#f8f8ee] text-white h-screen md:py-4 flex flex-col items-start z-50 relative`}>
        <div className={`flex px-4 items-center mb-4 w-full ${isSidebarCollapsed ? 'px-2 hidden' : 'justify-between'}`}>
          <div
            onClick={newChat}
            className={`text-xl font-bold text-primary ${isSidebarCollapsed ? 'hidden' : 'block'} cursor-pointer`}>
            <img src={logo} alt="" />
          </div>
        </div>
        <div className={`w-full gap-1 items-center px-4 mb-4 ${isSidebarCollapsed ? 'hidden' : 'flex flex-row'}`}>
          <button
            onClick={newChat}
            className={`primary-btn bg-primary hover:bg-primary-hover  ${isSidebarCollapsed ? 'w-full rounded-md' : 'w-full'}`}>
            {isSidebarCollapsed ? <BsPlus className="text-2xl" /> : 'New Chat'}
          </button>
        </div>
        <div className={`flex flex-col w-full gap-2 ${isSidebarCollapsed ? 'hidden' : 'block'}`}>
          {/*  <p className="text-sm px-2 font-semibold pt-2 select-none text-gray-400">Chat History</p>
        <ul className="list-none p-0 m-0 flex-1">
          {chatHistory.map((chat, index) => (
            <li key={index} className="py-2 cursor-pointer hover:bg-[#f5f5f510] px-2 rounded-lg text-sm">
              {chat}
            </li>
          ))}
        </ul> */}
          <div className="w-full pl-4">
            {/*   {appStateContext?.state.isChatHistoryOpen &&
            appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured && <ChatHistoryPanel />} */}
            <ChatHistoryPanel />
          </div>
        </div>
      </motion.aside>
    </div>
  )
}

export default Sidebar
